import { render, staticRenderFns } from "./Preregistrations.vue?vue&type=template&id=3bdcbe2e&"
import script from "./Preregistrations.vue?vue&type=script&lang=js&"
export * from "./Preregistrations.vue?vue&type=script&lang=js&"
import style0 from "./Preregistrations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports